import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetAssessmentsAuthenticationFieldsQuery } from 'services/assessmentsService';
import { useAssessmentsPaths } from './useAssessmentsPaths';
import { hasStatusCode, isClientError } from '../utils/assessmentsErrorUtils';

export const useAssessmentsAuthConfig = () => {
  const { tenantId } = useAssessmentsPaths();
  const {
    data: authenticationFields,
    isFetching: fetchingAuthConfig,
    error,
    refetch,
  } = useGetAssessmentsAuthenticationFieldsQuery(tenantId ?? skipToken);

  const isShowNotFound = useMemo(() => {
    if (!error || !hasStatusCode(error)) return false;
    const { status } = error as { status: number };
    return isClientError(status); // Only 404 errors
  }, [error]);

  return {
    authenticationFields,
    fetchingAuthConfig,
    error,
    isShowNotFound,
    refetch,
  };
};
